import React from 'react';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { SinglePackedUnits } from './SinglePackedUnits';
import { MultiDestinationPackedUnits } from './MultiDestinationPackedUnits';
import { MultSizePackedUnits } from './MultSizePackedUnits';
import { MultiSingleSizePackedUnits } from './MultiSingleSizePackedUnits';
import { usePurchaseOrderState } from '../../PurchaseOrderContext/index';
import { currency_symbols, roundingOff } from '../../../../../Components/helper';

export function RenderColourSection({ data, parentI, totalData, fromPreview, isPublicPoPage, isProductArchived }) {
  const { t } = useTranslation('common');

  const {
    purchaseOrderState: { selectedCurrency },
    disableConditions,
    poAddEditAccess,
  } = usePurchaseOrderState();

  const handleRanderRatiopack = () => {
    if ((!isEmpty(data?.ratioPacks) && totalData?.visible?.ratio) || (fromPreview && isPublicPoPage && data?.ratioPacks)) {
      return <MultiDestinationPackedUnits data={data?.ratioPacks} parentIndex={parentI} parentData={data} isProductArchived={isProductArchived} />;
    }
  };

  const handleRanderMultiplepack = () => {
    if ((!isEmpty(data?.multiplePacks) && totalData?.visible?.multiple) || (fromPreview && isPublicPoPage && data?.multiplePacks)) {
      return <MultiSingleSizePackedUnits data={data?.multiplePacks} parentIndex={parentI} totalData={totalData} />;
    }
  };

  const handleRanderSingularpack = () => {
    if ((!isEmpty(data?.sigularPackedUnits) && totalData?.visible?.singular) || (fromPreview && isPublicPoPage && data?.multiplePacks)) {
      return <SinglePackedUnits data={data?.sigularPackedUnits} parentIndex={parentI} />;
    }
  };

  const handleRanderMultipleTotalPack = () => {
    if ((!isEmpty(data?.multipleTotalPacks) && totalData?.visible?.multipleTotalPacks) || (fromPreview && isPublicPoPage && data?.multipleTotalPacks)) {
      return <MultSizePackedUnits data={data?.multipleTotalPacks} parentIndex={parentI} />;
    }
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2">
        <strong>{`Colourway : ${data?.colorWay?.name} `}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <FormGroup>
          {handleRanderSingularpack()}
          {handleRanderMultiplepack()}
          {handleRanderMultipleTotalPack()}
          {(!isEmpty(data?.ratioPacks) && totalData?.visible?.ratio) || (fromPreview && isPublicPoPage && data?.ratioPacks) ? (
            handleRanderRatiopack()
          ) : (
            <Row className="span_font_size">
              <Col lg={6}>
                <div className="py-1">
                  <span>{`Total Units of '${data?.colorWay?.name}' Colourway:`}</span>
                  <input
                    type="text"
                    name="grandTotalUnit"
                    placeholder={t('FILTER.GRAND_TOTAL_UNIT')}
                    className="form-control showBtmBrdr"
                    readOnly
                    disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                    value={(data?.grandTotalUnit ? new Intl.NumberFormat().format(roundingOff(data?.grandTotalUnit, 2)) : null) || ''}
                  />
                </div>
                {data?.totalBeforeDisc !== data?.totalAfterDisc && (
                  <div className="py-1">
                    <span>{`Total Price (After Discount): of '${data?.colorWay?.name}' Colourway:`}</span>
                    <div className="d-flex">
                      <input
                        type="text"
                        name="totalAfterDisc"
                        placeholder={t('FILTER.TOTAL_AFTER_DISCOUNT')}
                        disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                        className="form-control showBtmBrdr"
                        readOnly
                        value={(data?.totalAfterDisc ? new Intl.NumberFormat().format(roundingOff(data?.totalAfterDisc, 2)) : null) || ''}
                      />
                      <span className="px-1">
                        {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                      </span>
                    </div>
                  </div>
                )}
              </Col>
              <Col lg={6}>
                <div className="py-1">
                  <span>
                    {data?.totalBeforeDisc === data?.totalAfterDisc
                      ? `Total Price Per Unit of '${data?.colorWay?.name}' Colourway:`
                      : `Total Price (Before Discount): of '${data?.colorWay?.name}' Colourway:`}
                  </span>
                  <div className="d-flex">
                    <input
                      type="text"
                      name="totalBeforeDisc"
                      placeholder={t('FILTER.TOTAL_AFTER_DISCOUNT')}
                      className="form-control showBtmBrdr"
                      readOnly
                      disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                      value={(data?.totalBeforeDisc ? new Intl.NumberFormat().format(roundingOff(data?.totalBeforeDisc, 2)) : null) || ''}
                    />
                    <span className="px-1">
                      {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </FormGroup>
      </Card.Body>
    </Card>
  );
}

export default RenderColourSection;
